import * as axios from '~/utilities/axios'

export const fetchAllPlates = sessionToken => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/plates/query/all/enabled`)
    .then(res => res.data.results)
    .catch(axios.parseError)
}

export const fetchPlate = (objectId, sessionToken) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/plates/class/${objectId}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const fetchPlateByNumberAndState = (plateNumber, state, sessionToken, userEmail) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/plates/query/plate/${plateNumber}/${state}/${userEmail}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const updatePlate = (objectId, data, sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`/api/v1/plates/class/${objectId}`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const createPlate = (data, sessionToken) => {
  return axios
    .secure(sessionToken)
    .post('/api/v1/plates/class', data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const addImage = (objectId, data, type, sessionToken) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/plates/create/imageFile/${objectId}?imageType=${type}`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}
